var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"36","height":"36","fill":"#1C66EF","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"spinner_aj0A",attrs:{"d":"M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }